import React from "react";
import { useTranslation } from "react-i18next";

import { Resource } from "./resource";
import { AddMember } from "./addMember";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourcesList(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.resourcesList}>
      <div className={styles.resourceForm}>
        <AddMember
          project={props.project}
          projectResources={props.projectResources}
          addResources={props.addResources}
          removeResources={props.removeResources}
        />
      </div>
      <div className={styles.resources}>
        {props.projectResources.map((resource) => (
          <div className={styles.resource}>
            <Resource
              projectResource={resource}
              remove={(resource) => props.removeResources([resource])}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export { ResourcesList };
